import { useState, useEffect } from "react"
import { useLoggedUser } from "../../../hooks"

export const useRoleGuard = ({
  allowedRoles = [],
  allowedRegions
}) => {
  const { user } = useLoggedUser()
  const [userIsAllowed, setUserIsAllowed] = useState(false)

  useEffect(() => {
    const userRoles =  user?.roles || []

    const roleIsAllowed = (allowedRoles || [])
      .some(allowedRole => userRoles.includes(allowedRole))

    if (roleIsAllowed && Array.isArray(allowedRegions)) {
      const regionIsAllowed = allowedRegions
        .some(r => (user?.regions || []).includes(r))
      regionIsAllowed && setUserIsAllowed(true)
    }

    roleIsAllowed && setUserIsAllowed(true)
  }, [user, allowedRoles])

  return {
    userIsAllowed
  }
}

/**
 * Shows an empty (null) component if the passed roles or regions are not
 * part of the logged user
 * @param children
 * @param {string[]} allowedRoles
 * @param allowedRegions Will be ignored if it's not passed
 * @return {*|null}
 */
export function RoleGuard ({
  children,
  allowedRoles = [],
  allowedRegions
}) {
 const { userIsAllowed } = useRoleGuard({ allowedRoles, allowedRegions })
  return userIsAllowed ? children : null
}
